// assets
import { BranchesOutlined, MessageOutlined } from "@ant-design/icons";

import SpiderIcon from "@/components/icons/SpiderIcon";
import { NavItemType } from "@/types/menu";

// ==============================|| MENU ITEMS - AGENT TRAFFIC ||============================== //

const agentTraffic: NavItemType = {
  id: "group-agent-traffic",
  type: "group",
  title: "Agent Traffic",
  children: [
    {
      id: "conversations",
      title: "Conversations",
      type: "item",
      url: "/conversations",
      icon: MessageOutlined,
    },
    {
      id: "indexing",
      title: "Indexing",
      type: "item",
      url: "/indexing",
      icon: SpiderIcon,
    },
    {
      id: "journeys",
      title: "Journeys",
      type: "item",
      url: "/journeys",
      icon: BranchesOutlined,
      adminOnly: true,
    },
  ],
};

export default agentTraffic;
